import { dayjs } from '@mobi/utils/date'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { getBetLoopCanShareTickets } from '@core/Areas/BetLoop/helpers/api'
import { getKambiPendingBetHistory } from '@core/Areas/KambiSports/Player/helpers/api'

export const getKambiShareablePendingTickets = async (): Promise<FetchPendingTicketsData> => {
  const pendingKambiTicketsData = await getKambiPendingBetHistory()

  const kambiTickets: KambiHistoryCoupon[] = pendingKambiTicketsData?.historyCoupons ?? []
  if (kambiTickets.length === 0) return { data: [] }

  const canSharePayload = buildCanShareRequestPayload(kambiTickets)
  const canShareData = await getBetLoopCanShareTickets([], canSharePayload.betRefPairs)

  const shareableBets = canShareData.flatMap(ticket =>
    !ticket.canShare || !ticket.betRef ? [] : [ticket.betRef]
  )
  if (shareableBets.length === 0) return { data: [] }

  const filteredKambiTickets = kambiTickets.filter(
    historyCoupon =>
      historyCoupon.bets.some(bet => shareableBets.includes(bet.betRef)) &&
      historyCoupon.events.every(event => dayjs().isBefore(event.eventStartDate))
  )

  return { data: filteredKambiTickets }
}

// =============
// Local Helpers
// =============

const buildCanShareRequestPayload = (
  kambiTickets: KambiHistoryCoupon[]
): CanShareRequestPayload => {
  return {
    betRefPairs: kambiTickets.flatMap(coupon =>
      coupon.bets.map(bet => ({
        couponRef: coupon.couponRef,
        betRef: bet.betRef,
      }))
    ),
  }
}

// =====
// Types
// =====

type FetchPendingTicketsData = {
  data: KambiHistoryCoupon[]
}

interface CanShareRequestPayload {
  betRefPairs: { couponRef: number; betRef: number }[]
}
